import styled from 'styled-components';

const BoxedInputContainer = styled.div`
    display: inline-block;
    width: 100%;
    margin-bottom: 1.438rem;
    position: relative;

    /* .input_percent {
        color: #666666;
        position: absolute;
        font-size: 1rem;
        top: 2.8rem;
        right: 1.313rem;
    } */
`;

export default BoxedInputContainer;
